class FooterReassurance extends HTMLElement {
  constructor() {
    super();

    this.config = {
      autorotate: this.dataset.autorotate === 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
    };

    if (theme.config.mqlSmall) {
      this.initOnMobile();
    }

    document.addEventListener('matchSmall', () => {
      this.unload();
      this.initOnMobile();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
    });
  }

  initOnMobile() {
    if (this.dataset.activeMobileSlider === 'true') {
      this.initCarousel();
    }
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.removeNextPrevListeners();
    }

    if (this.observer && typeof this.observer.unobserve === 'function') {
      this.observer.unobserve(this);
    }
  }

  initCarousel() {
    if (this.dataset.blockCount == 1) {
      return;
    }

    const reassuranceSlider = this.querySelector('.multicolumn-list');
    setTimeout(() => {
      this.flickity = new Flickity(reassuranceSlider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        autoPlay: this.config.autorotate ? this.config.autorotateSpeed : false,
      });
    });
  }
}
customElements.define('footer-reassurance', FooterReassurance);
